var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpowerSmbs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VW0bGZ.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.36,37.54l-.03-14.13-5.42-.03-.31-.47c-.12-.18-.28-.57-.03-1.11L21.51,2.46l.02,12.56v1.63s5.1.03,5.1.03c.4.07.72.36.83.78l.09.35-9.2,19.74ZM14.96,21.4l5.36.02v7.13s4.63-9.91,4.63-9.91h-5.44s.01-3.64.01-3.64v-3.51s-4.57,9.89-4.57,9.89ZM14.39,22.65h0s0,0,0,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerSmbs);
export default __webpack_public_path__ + "static/media/empower-smbs.e6f35ae0c567b5de9f84ca955893d1c1.svg";
export { ForwardRef as ReactComponent };